import { render, staticRenderFns } from "./CollapseMyProfile.vue?vue&type=template&id=e71ec092&scoped=true&"
import script from "./CollapseMyProfile.vue?vue&type=script&lang=js&"
export * from "./CollapseMyProfile.vue?vue&type=script&lang=js&"
import style0 from "./CollapseMyProfile.vue?vue&type=style&index=0&id=e71ec092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71ec092",
  null
  
)

export default component.exports